import React, { useState } from "react";
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const StatuteHighlights = () => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Alert
      severity="info"
      icon="🌟"
      sx={{
        borderRadius: 2,
        "& .MuiAlert-message": {
          width: "100%",
        },
      }}
    >
      <Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onClick={() => setExpanded(!expanded)}
          sx={{ cursor: "pointer", userSelect: "none" }}
        >
          <Typography variant="body2" fontWeight="600">
            Witaj w Natchnieniu!
          </Typography>
          <IconButton size="small" sx={{ ml: 1 }}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={expanded}>
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Zanim się zapiszesz, poznaj kilka prostych zasad, które pomagają
              nam dbać o komfort wszystkich:
            </Typography>

            <Box component="ul" sx={{ mt: 1.5, mb: 1, pl: 2 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2">
                   <strong>Możesz się wypisać do 24h przed zajęciami</strong>{" "}
                  - wejście automatycznie wraca na Twoje konto
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2">
                   <strong>Pamiętaj o terminie</strong> - jeśli zapomnimy
                  wypisać się na czas, zajęcia liczą się jako wykorzystane
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2">
                   <strong>Karnety mają ważność</strong> - niewykorzystane
                  wejścia przepadają po terminie (sprawdź swój karnet!)
                </Typography>
              </Box>
            </Box>

            <MuiLink
              href={`${process.env.PUBLIC_URL}/statute`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-block",
                mt: 1,
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              Zobacz pełny regulamin →
            </MuiLink>
          </Box>
        </Collapse>
      </Box>
    </Alert>
  );
};

export default StatuteHighlights;
